// extracted by mini-css-extract-plugin
export default {"testSearch":"_14Grpe_mCmCvkDuoPeFml1","text-map":"iv1MD2NSL9Z81um_F7nFe","col-lg-8":"_3CPwJwAycGDw1ay-8GRFqa","col-lg-4":"_2MgFpmYIJNWWAz-k0hYlv0","toggle":"_1JwsiMcby0SH3Gy6WufiM7"};